import { Plane } from "lucide-react";
import Image from "next/image";

type PropsType = {
  title: string;
  countryFlag: string;
  countryName: string;
  description: string;
};

function CountryHeadingWithFlag({
  countryFlag,
  countryName,
  title,
  description,
}: PropsType) {
  return (
    <>
      <span className="flex items-center justify-center gap-2 text-sm font-500 text-foreground dark:text-primary-foreground sm:text-body-base xl:text-primary-foreground">
        <Plane className="size-4 sm:size-[22px]" />
        <span>{title} </span>
      </span>
      <span className="flex items-center justify-center gap-2 sm:gap-3">
        <span className="relative inline-block h-[32px] w-[32px] shrink-0 sm:h-[40px] sm:w-[40px]">
          <Image
            src={countryFlag}
            alt={`${countryName} flag`}
            fill
            sizes="auto"
            className="shrink-0 rounded-full object-cover shadow-md"
            priority
          />
        </span>

        <span className="font-montserrat text-[20px] font-700 text-foreground dark:text-primary-foreground sm:text-h1-base md:text-[30px] xl:text-primary-foreground">
          {description}
        </span>
      </span>
    </>
  );
}

export default CountryHeadingWithFlag;
